import { Button } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import { toast } from "react-toastify";
import { assignFlag } from "../../../../services/flag";
import { useParams } from "react-router-dom";
import {
  updateFlagDetails,
  useSelectFlagData,
} from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useDispatch } from "react-redux";

const Unlock = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const flagData = useSelectFlagData();

  const { assigneeId, locked } = flagData?.flagDetails || {};

  const showUnlock = locked && !!assigneeId;

  const mutateUnlock = useMutation({
    mutationKey: ["unlock-flag-mq"],
    mutationFn: (flagId) =>
      assignFlag({
        flagId,
        assign: false,
      }),
    onSuccess: async ({ data }) => {
      dispatch(updateFlagDetails(data)); // TODO - Сашо - не връща свежи данни
      toast.success("Flag successfully unlocked");
    },
    onError: (err) => {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to unlock flag");
    },
  });

  if (!showUnlock) return null;

  return (
    <Button
      loading={mutateUnlock.isPending}
      onClick={() => mutateUnlock.mutate(id)}
      variant="outline"
    >
      Unlock
    </Button>
  );
};

export default Unlock;
